import React, {Component} from 'react'
import { connect } from 'react-redux'
import Heading from 'grommet/components/Heading'
import Waypoint from 'react-waypoint'
import SeparatorBar from '../SeparatorBar'
import { setSectionProperty } from '../../actions/sections/SectionsActions'
import './ServicesListPart2.css'

@connect((state) => ({
  separatorBarExpanded: state.sectionsReducer.servicesPart2.separatorBarExpanded
}), { setSectionProperty })
class ServicesListPart2 extends Component {

  onEnter = () => {
    const { setSectionProperty } = this.props
    setSectionProperty('servicesPart2', 'separatorBarExpanded', true)
    setSectionProperty('services', 'sectionThreeSeparatorExpanded', true)
  }

  onLeave = () => {
    const { setSectionProperty } = this.props
    setSectionProperty('servicesPart2', 'separatorBarExpanded', false)
    setSectionProperty('services', 'sectionThreeSeparatorExpanded', false)
  }

  render() {
    const { separatorBarExpanded } = this.props
    const separatorClassName = `ServicesListPart2-separatorBar${ separatorBarExpanded ? ' is-expanded' : ''}`
    return (
      <Waypoint onEnter={this.onEnter} scrollableAncestor={window} onLeave={this.onLeave}>
        <div className="ServicesListPart2" style={this.props.style}>
          {!this.props.isMobile && <SeparatorBar className={separatorClassName} />}
          <div className="ServicesListPart2-left">
            <Heading className="ServicesListPart2-heading" tag="h2" uppercase={true} strong={true}>Experience</Heading>
            <Heading className="ServicesListPart2-description" tag="h4" strong={false} size='small'>
              Good user experience will make your users fall in love with your project. What sets us apart from our
              competition is our understanding of combining design, ux with code. This makes our applications from web to
              mobile both intuitive and unique.
            </Heading>
            <Heading className="ServicesListPart2-heading" tag="h2" uppercase={true} strong={true}>What we do best</Heading>
            <Heading className="ServicesListPart2-description" tag="h4" strong={false} size='small'>
              We are passionate coders using the most suitable and innovative technologies. We code according to best
              practices ensuring high quality and future proof applications.
            </Heading>
          </div>
          <div className="ServicesListPart2-right">
            <Heading className="ServicesListPart2-heading" tag="h2" uppercase={true} strong={true}>Development</Heading>
            <Heading className="ServicesListPart2-description" tag="h4" strong={false} size='small'>
              We develop web applications, websites and mobile apps. We aim to create innovative digital experiences to
              engage customers from the start. Contact us about your project, be it a website, web application or mobile
              app.
            </Heading>
            <Heading className="ServicesListPart2-heading" tag="h2" uppercase={true} strong={true}>A unique company</Heading>
            <Heading className="ServicesListPart2-description" tag="h4" strong={false} size='small'>
              We really enjoy doing what we do. Besides our years of experience, our passion is what defines us the most.
              We are artistic by nature and enjoy creating digital products for your business.
              This is evident through our dedication to each project we work on.
            </Heading>
          </div>
        </div>
      </Waypoint>
    )
  }
}

export default ServicesListPart2


// WEBPACK FOOTER //
// ./src/components/ServicesListPart2/index.js